<template>
  <div>
    <!-- MODO “TELA NORMAL”: seleção de período + botão Executar -->
    <div v-if="!printMode">
      <h6>Prospects que Geraram Matrícula</h6>
      <p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <label>Data Início:</label>
          <input
            type="date"
            v-model="dataInicioLocal"
            class="form-control"
          />
        </div>
        <div class="col-auto">
          <label>Data Fim:</label>
          <input
            type="date"
            v-model="dataFimLocal"
            class="form-control"
          />
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">
            Executar
          </button>
        </div>
      </div>
    </div>

    <!-- MODO “IMPRESSÃO / PRINT” -->
    <div v-else class="relatorio-body" :data-user="props.userName">
      <p class="text-center" style="font-size: 14px;">
        ( {{ globalUtils.formatarData(dataInicio) }} a
        {{ globalUtils.formatarData(dataFim) }} )
      </p>

      <div v-if="loading">Carregando…</div>

      <div v-else>
        <!-- Resumo -->
        <div v-if="resumo" class="mt-2">
          <h6>Resumo</h6>
          <table class="table table-bordered table-sm" style="font-size: 12px;">
            <thead>
              <tr>
                <th style="width: 33%;">Prospects no período</th>
                <th style="width: 33%;">Matrículas realizadas</th>
                <th style="width: 34%;">Percentual</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ resumo.total_prospects }}</td>
                <td>{{ resumo.total_matriculas }}</td>
                <td>{{ formatarNumero(resumo.percentual) }}%</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Tabela de detalhes -->
        <div v-if="registros.length">
          <h6>Prospects que geraram matrícula</h6>
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 8%;">ID</th>
                <th style="width: 40%;">Prospect</th>
                <th style="width: 32%;">Ação</th>
                <th style="width: 10%;">Matrícula</th>
                <th style="width: 10%;">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in registros" :key="'prospect-' + idx">
                <td>{{ item.id }}</td>
                <td>
                  Contato: {{ item.nome_contato }} -
                  registrado em: {{ globalUtils.formatarData(item.data_contato) }}
                </td>
                <td>{{ item.texto_acao }}</td>
                <td>{{ item.matricula_id || '-' }}</td>
                <td>{{ item.status_matricula || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <p class="text-muted">
            Nenhum prospect com matrícula encontrada para este período.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'

const props = defineProps({
  printMode:  { type: Boolean, default: false },
  dataInicio: String,
  dataFim:    String,
  printTitle: { type: String, default: 'Relatório' },
  subtitle:   { type: String, default: '' },
  userName:   { type: String, default: '' }
})

const router = useRouter()

// Estados para modo “tela normal”
const dataInicioLocal = ref('')
const dataFimLocal    = ref('')

// Estados para modo “print”
const loading   = ref(false)
const resumo    = ref(null)
const registros = ref([])

// Se estivermos em printMode, buscar os dados assim que montar
onMounted(async () => {
  if (!props.printMode) return
  if (!props.dataInicio || !props.dataFim) return

  await carregarDados(props.dataInicio, props.dataFim)
})

async function carregarDados (dataInicio, dataFim) {
  loading.value = true
  try {
    const res = await axios.get(
      '/gestao/relatorios/operacionais/prospeccao-matriculas',
      { params: { dataInicio, dataFim } }
    )
    resumo.value    = res.data.resumo || null
    registros.value = Array.isArray(res.data.registros)
      ? res.data.registros
      : []
  } catch (e) {
    console.error('Erro ao buscar prospects que geraram matrícula:', e)
    resumo.value    = null
    registros.value = []
  } finally {
    loading.value = false
  }
}

// Redireciona para o ReportPrintWrapper com as datas e subtitle
function abrirPrint () {
  if (!dataInicioLocal.value || !dataFimLocal.value) return

  const inicioFormatado = globalUtils.formatarData(dataInicioLocal.value)
  const fimFormatado    = globalUtils.formatarData(dataFimLocal.value)
  const subtitle        = `( ${inicioFormatado} a ${fimFormatado} )`

  router.push({
    path: `/gestao/relatorios/print/prospeccao-matriculas`,
    query: {
      title:      'Prospects que Geraram Matrícula',
      dataInicio: dataInicioLocal.value,
      dataFim:    dataFimLocal.value,
      subtitle:   subtitle
    }
  })
}

function formatarNumero (valor) {
  if (valor == null || isNaN(valor)) return '0,00'
  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.text-muted {
  font-size: 13px;
}
</style>
